import { toggleDarkModeAndRender } from 'scripts/lib/utils'
export default {
  soompi: [
    // { name: 'Soompi', link: '/', id: 'soompi' },
    // { name: 'Rakuten Viki', image: RakutenVikiLogo, link: 'https://viki.com', id: 'rakuten-viki' }
    // { name: 'Rakuten', link: 'https://rakuten.com', id: 'rakuten' }
  ],
  profile: [
    { name: 'Edit Profile', link: '/user/edit', id: 'profile' },
    { name: 'Manage Rakuten ID', link: '/', id: 'rakuten-id' },
    { name: '', id: 'dark-mode', link: '/', callback: toggleDarkModeAndRender, classes: 'navbar-dropdown-link navbar-link active-route dark-mode-link' }
  ],
  primary: [
    { name: 'Explore',
      subs: {
        updates: [
          { name: 'Latest', link: '/latest', id: 'latest' },
          { name: 'Trending', link: '/trending', id: 'trending' },
          { name: 'Popular', link: '/popular', id: 'popular' },
          { name: 'Breaking', link: '/category/breaking', id: 'sub-breaking' }
        ],
        main: [
          { name: 'MV/Teaser', link: '/category/mvteaser', id: 'mv-teaser' },
          { name: 'Drama', link: '/category/drama', id: 'drama' },
          { name: 'Culture', link: '/category/culture-and-society', id: 'culture-and-society' },
          { name: 'Exclusives', link: '/category/exclusive', id: 'exclusives' }
        ],
        other: [
          { name: 'Community', link: 'https://www.soompi.com/community', id: 'community' },
          { name: 'Forums', link: 'https://forums.soompi.com/', id: 'forum' },
          { name: 'Apps', link: '/apps', id: 'app' },
          { name: 'Viki', link: 'https://www.viki.com/', id: 'viki' }
        ]
      },
      id: 'explore',
      // point to the dropdown we want to target when this link is clicked
      dropdown: 'expanded-explore',
      link: 'javascript:;',
      // The id of the parent navigation. This is important to prevent parent navigation from collapsing when the subnavigation is clicked
      contextual: 'primary'
    },
    { name: 'Quiz', link: '/category/quizzes', id: 'quiz' },
    { name: 'Video', link: '/category/video', id: 'video' },
    { name: 'Celeb', link: '/category/celeb', id: 'celeb' },
    { name: 'Style', link: '/category/fashionbeauty', id: 'fashion-beauty' },
    { name: 'TV/Film', link: '/category/tvfilm', id: 'tvfilm' },
    { name: 'Music', link: '/category/music', id: 'music' },
    { name: 'Features', link: '/category/feature', id: 'features' }
  ]
}



// WEBPACK FOOTER //
// ./assets/js/components/navigations/helpers/navItems/en.js